import { ITable } from './Table';

// Shared enum matching C# FeatureFlag enum
export enum FeatureFlag {
  UNDEFINED = 'undefined',
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}

// Default feature flags configuration
export const DEFAULT_FEATURE_FLAGS: Record<string, FeatureFlag> = {
  webCatalogue: FeatureFlag.ENABLED,
  baseCatalogue: FeatureFlag.UNDEFINED,
  education: FeatureFlag.DISABLED,
  costCalculation: FeatureFlag.DISABLED,
  shareOptions: FeatureFlag.UNDEFINED,
  longGoodsConfig: FeatureFlag.UNDEFINED,
};

export const App = {
  Population: {
    PUBLIC_FIELDS: ['_id', 'appName', 'logo', 'summaryDescription'] as const,
    SUBSCRIPTION_INFO_FIELDS: [
      'appName',
      'logo',
      'plattforms',
      'metadata',
      'two_part_connector_selection',
    ] as const,
    LICENSE_FIELDS: ['licenseName', 'app_id', 'featureFlags'] as const,
  },
} as const;

export interface IApp {
  _id: string;
  appName: string;
  adminUser_ids: string[];
  logo: string;
  userLimit: number;
  modelLimit: number;
  plattforms: string[];
  summaryDescription: string;
  two_part_connector_selection: ITable | null;
  metadata: ITable | null;
  allowExternalListing: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IAppPublic extends Pick<IApp, (typeof App.Population.PUBLIC_FIELDS)[number]> {}

export interface IAppLicense {
  _id: string;
  app_id: string;
  licenseName: string;
  featureFlags: Record<string, FeatureFlag>;
  // featureSettings?: Record<string, any>; // For future complex feature configuration
}

export interface IAppSubscription {
  _id: string;
  appLicense_id: string;
  email: string;
  expirationDate: Date | string;
}

export interface IAppSubscriptionPublicInfo {
  subscription: IAppSubscription;
  license: IAppLicense;
  app: Pick<IApp, (typeof App.Population.SUBSCRIPTION_INFO_FIELDS)[number]>;
}
